module.exports = __webpack_public_path__ + "img/Aysb.66d1ba60.svg";